import { IAbo } from '../api/model/IAbo';

const STORAGE_KEY = 'allocatus_recently_linked';
const MAX_ITEMS = 5;

export const addRecentlyLinked = (abo: IAbo): void => {
  const existing = getRecentlyLinked();
  const updated = [abo, ...existing.filter(a => a.Id !== abo.Id)].slice(0, MAX_ITEMS);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
};

export const getRecentlyLinked = (): IAbo[] => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
};
